// The canvas every template lives inside. Provides the deep-void radial
// background, viewport sizing, and edge padding per §0.6.

import type { ReactNode } from 'react';

interface StageProps {
  children: ReactNode;
  className?: string;
}

export function Stage({ children, className = '' }: StageProps) {
  return (
    <div className="relative w-screen h-[100dvh] overflow-hidden bg-void-radial text-fg">
      <div className={`absolute inset-0 px-20 py-24 max-md:px-6 max-md:py-10 flex ${className}`}>
        {children}
      </div>
    </div>
  );
}
